import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AccountService } from '../../../account/account.service';
import { CashInService } from '../cashIn.service';
import { CashInModel } from '../cashIn.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cashIn',
  templateUrl: './cashIn.component.html',
  styleUrls: ['./cashIn.component.scss'],
})
export class CashInComponent {
  cashIn = new FormGroup({
    email: new FormControl<string>('', [
      Validators.required,
      Validators.email,
    ]),
    nome: new FormControl<string>('', Validators.required),
    valor: new FormControl<number | null>(null, [
      Validators.required,
      Validators.min(1),
    ]),
    taxa: new FormControl<number>(0),
    valorTotal: new FormControl<number>(0),
  });

  public isSubmitted: boolean;
  public emailFeedBack: string;
  public nomeFeedBack: string;
  public valorFeedBack: string;

  public depositTaxValue: number = 0;
  public depositTaxPercent: number = 0;

  public isLoaded: boolean;

  public checkoutUrl: string = '';
  public depositSuccess = false;

  constructor(
    private accountService: AccountService,
    private cashInService: CashInService,
    private toastr: ToastrService
  ) {
    this.getAccountValues();
    this.isSubmitted = false;
    this.emailFeedBack = '';
    this.nomeFeedBack = '';
    this.valorFeedBack = '';
    this.isLoaded = true;
  }

  public getAccountValues() {
    this.accountService.getAccount().then((value) => {
      this.depositTaxValue = value.depositTaxValue;
      this.depositTaxPercent = value.depositTaxPercent;
    });
  }

  public openCheckoutUrl(): void {
    if (this.checkoutUrl) {
      window.open(this.checkoutUrl, '_blank');
    }
  }

  public transformValue = (value: string | number | undefined | null): string => {
    return String(Number(value) / 100);
  };

  public valorChanged() {
    const valor = Number(this.cashIn.controls.valor.value);
    this.cashIn.controls.valor.setValue(valor);
    let taxa = (valor * this.depositTaxPercent) / 100;
    taxa = valor > 0 ? taxa + this.depositTaxValue : 0;
    const valorTotal = valor > 0 ? valor - taxa : 0;
    this.cashIn.controls.taxa.setValue(taxa);
    this.cashIn.controls.valorTotal.setValue(valorTotal);
  }

  makeDeposit(): void {
    this.isSubmitted = true;

    if (!this.formIsValid()) {
      return;
    }

    const payload = this.buildPayload();
    this.sendRequest(payload);
  }

  private buildPayload(): CashInModel {
    const model = new CashInModel();

    const now = new Date();
    const oneDayMs = 24 * 60 * 60 * 1000;
    const due = new Date(now.getTime() + oneDayMs);

    model.dueDate = due.toISOString();

    model.person.name = this.cashIn.value.nome || '';
    model.person.email = this.cashIn.value.email || '';
    model.value = Number(this.cashIn.value.valor) || 0;
     model.idempotencyKey = this.generateIdempotencyKey();

    return model;
  }

  private sendRequest(request: CashInModel): void {
    this.cashInService.sendDeposit(request).subscribe({
      next: (res) => {
        if (res.success) {
          this.checkoutUrl = res.checkoutLink;
          this.depositSuccess = true;
          this.toastr.success(
            res.message || 'Depósito criado com sucesso!'
          );
        } else {
          this.toastr.error(res.message || 'Erro ao criar depósito.');
        }
      },
      error: (err) => {
        const errorMsg =
          err?.error?.message || 'Erro inesperado ao criar depósito.';
        this.toastr.error(errorMsg);
      },
    });
  }

  public copyLinkToClipboard(): void {
    navigator.clipboard
      .writeText(this.checkoutUrl)
      .then(() =>
        this.toastr.success('Link copiado para a área de transferência!')
      )
      .catch(() => this.toastr.error('Erro ao copiar o link.'));
  }

  public formIsValid(): boolean {
    if (this.cashIn.controls.email.hasError('required')) {
      this.emailFeedBack = 'E-mail é obrigatório!';
    } else if (this.cashIn.controls.email.hasError('email')) {
      this.emailFeedBack = 'E-mail inválido!';
    } else {
      this.emailFeedBack = '';
    }

    if (this.cashIn.controls.nome.invalid) {
      this.nomeFeedBack = 'Nome é obrigatório!';
    } else {
      this.nomeFeedBack = '';
    }

    if (this.cashIn.controls.valor.hasError('min')) {
      this.valorFeedBack = 'Valor inválido - Valor mínimo 1,00!';
    } else if (this.cashIn.controls.valor.invalid) {
      this.valorFeedBack = 'Valor é obrigatório!';
    } else {
      this.valorFeedBack = '';
    }

    return this.cashIn.valid;
  }

  private generateIdempotencyKey(): string {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    return Array.from(bytes)
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  }
}
